import { DappInfoComponent } from '@/general/src/dapp/webapp.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { RichText } from '@/webapp/src/components/other/RichText/index.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { downloadRoute } from '@/webapp/src/lib/routes.js'
import { Block, Segments } from '@/webapp/src/lib/uninty.components.js'
import { Link } from 'react-router-dom'

export const HomePage = withPageWrapper({
  isTitleExact: true,
  title: 'СтрахоБот',
  Layout: GeneralLayout,
})(() => {
  return (
    <Block fcnw>
      <Segments>
        <RichText>
          <h1>
            <strong>🚀 СтрахоБот — автоматизация работы страхового агента</strong>
          </h1>
          <h2 id="⏳-экономит-агенту-до-115-часов-в-месяц">⏳ Экономит агенту до 115 часов в месяц</h2>
          <p>
            <strong>Сколько времени уходит у вас сейчас?</strong>
          </p>
          <ul>
            <li>
              5 клиентов в день = <strong>~100 клиентов</strong> в месяц
            </li>
            <li>
              На каждого — <strong>5 расчётов</strong> в разных страховых = <strong>500 расчётов</strong> в месяц
            </li>
            <li>
              Каждый расчёт вручную занимает <strong>~15 минут</strong>
            </li>
            <li>
              Итого: <strong>125 часов</strong> в месяц только на расчёты
            </li>
          </ul>
          <p>
            <strong>Со «СтрахоБотом» всё иначе:</strong>
          </p>
          <ul>
            <li>
              Программа делает все расчёты во всех страховых параллельно для одного клиента за <strong>~5 минут</strong>
            </li>
            <li>
              На те же <strong>500 расчётов</strong> уходит всего <strong>~10 часов</strong> в месяц
            </li>
          </ul>
          <p>
            <strong>
              🎯 Вы экономите 125-10=115 часов каждый месяц, которые можете потратить на клиентов, отдых или новые
              сделки.
            </strong>
          </p>
          <hr />
          <h2 id="🌟-как-это-работает">🌟 Как это работает</h2>
          <p>1️⃣ Скачайте программу на компьютер</p>
          <p>2️⃣ Загрузите фото документов клиента (паспорт, права, СТС, ПТС и т.д.)</p>
          <p>3️⃣ Программа за секунды распознает все данные загруженных документов</p>
          <p>4️⃣ Выбераете тип страховки: ОСАГО, КАСКО и т.д.</p>
          <p>5️⃣ Выбераете нужные страховые компании: Альфастрахование, Ингострах, ВСК, Росгосстрах и др.</p>
          <p>6️⃣ Программа откроет браузер и сама заполнит все поля на сайтах страховых за вас</p>
          <p>7️⃣ Через пару минут получите все предложения в удобной таблице</p>
          <p>
            8️⃣ Все расчеты сохраняются — можно вернуться к ним в любой момент и продолжить оформление прямо на сайте
            нужной страховой
          </p>
          <hr />
          <h3 id="а-почему-не-интеграторы-вроде-sravniru">
            <strong>А почему не интеграторы вроде sravni.ru?</strong>
          </h3>
          <p>
            Многие агенты пробуют работать с классическими интеграторами — но быстро понимают их ограничения:
            <br /> 🔹 <strong>Нужно менять брокера и процессы.</strong> Чтобы подключиться к интегратору, вы часто
            заключаете новые договоры, переходите на чужие условия и передаете клиентов под чужой контроль.{' '}
          </p>
          <p>
            {' '}
            🔹 <strong>Жесткие рамки и ограничения.</strong> Интеграторы зависят от API страховых компаний — а значит,
            работают только в рамках того, что разрешает страховщик. Многие полезные функции реализовать просто
            невозможно.{' '}
          </p>
          <p>
            {' '}
            🔹 <strong>Зависимость от чужих систем.</strong> Стоит страховщику сменить технический протокол или внести
            изменения в API — интегратор ломается, а вы теряете время и деньги.
          </p>
          <hr />
          <h3 id="📊-страхобот--это-подругому">
            <strong>📊 СтрахоБот — это по‑другому:</strong>
          </h3>
          <p>
            ✅ <strong>Вы не меняете своих доступов и брокера.</strong>
            <br /> Все расчеты и полисы оформляются через ваши собственные личные кабинеты страховых компаний. Программа
            просто автоматизирует ваши действия, без каких‑либо рисков.
          </p>
          <p>
            ✅ <strong>Независимость от страховых компаний и их API.</strong>
            <br /> Мы работаем на вашем компьютере, через ваш браузер. Нас не ограничивают правила интеграции, мы не
            завязаны на изменения технической документации.
          </p>
          <p>
            ✅ <strong>Гибкость и развитие.</strong>
            <br /> Нужна новая функция? Мы можем её реализовать, не спрашивая разрешения у страховой. Всё подстраивается
            под ваши потребности и процессы.
          </p>
          <hr />
          <p>
            С <strong>СтрахоБотом</strong> вы сохраняете полный контроль над клиентами и процессами, не жертвуете
            привычными условиями работы — и при этом экономите время и зарабатываете больше.
          </p>
          <hr />
          <h2 id="🛠-что-умеет-страхобот">
            <strong>🛠 Что умеет СтрахоБот?</strong>
          </h2>
          <p>
            🔹 Работает с физ. лицами и двумя типами страховок: ОСАГО и КАСКО. В планах добавить юридические лица и
            другие типы страховок.
          </p>
          <p>
            🔹 Работает с 5 страховыми: Альфастрахование, Ингострах, ВСК, Росгосстрах, Ренессанс. В планах подключить 15
            страховых компаний.
          </p>
          <p>🔹 Автоматически заполняет данные клиента в кабинетах страховых</p>
          <p>🔹 Сохраняет историю расчетов и показывает их в сравнительной таблице</p>
          <p>🔹 Позволяет быстро перейти к нужному договору</p>
          <p>🔹 Поддерживает два уровня точности распознавания документов клиента: 75–80% и 99%</p>
          <p>🔹 Гибко развивается — новые функции появляются по вашим запросам</p>
          <hr />
          <h2 id="🌟-что-вы-получите-со-страхоботом">
            <strong>🌟 Что вы получите со СтрахоБотом?</strong>
          </h2>
          <p>
            ✅ <strong>Работаете так, как привыкли — только быстрее.</strong>
            <br /> Больше не нужно менять брокера, пересматривать договоры или подстраиваться под чужие правила. Всё
            остаётся по‑старому — только рутинную работу теперь делает программа.
          </p>
          <p>
            ✅ <strong>Ошибок меньше, клиентов больше.</strong>
            <br /> Программа распознаёт документы с точностью до 99% и сама заполняет поля за вас. Вы больше не тратите
            время на перепечатки и меньше рискуете ошибиться.
          </p>
          <p>
            ✅ <strong>Спокойствие и уверенность.</strong>
            <br /> Мы следим за корректностью работы сценариев, устраняем сбои и постоянно обновляем систему. Вы можете
            сосредоточиться на клиентах, а не на технике.
          </p>
          <p>
            ✅ <strong>Рост и развитие вместе с вами.</strong>
            <br /> Если вам нужны новые функции или новые страховые — мы добавим их по вашему запросу. Программа
            развивается под ваши задачи.
          </p>
          <p>
            ✅ <strong>До 5 раз больше расчетов за день.</strong>
            <br /> Сокращайте время на оформление в 3–5 раз и обслуживайте больше клиентов в те же рабочие часы.
          </p>
          <p>
            ✅ <strong>Конкурентное преимущество.</strong>
            <br /> Предлагайте клиентам лучшие условия, оставаясь на привычных комиссиях и договоренностях.
          </p>
          <p>
            ✅ <strong>Чистая история и контроль.</strong>
            <br /> Вся история расчетов сохраняется в удобной таблице с поиском — вы всегда можете поднять старый расчет
            и сравнить предложения.
          </p>
          <p>
            ✅ <strong>Гибкость без ограничений.</strong>
            <br /> Мы не зависим от API страховых компаний, поэтому можем быстро внедрять новые возможности, не
            дожидаясь их разрешений.
          </p>
          <p>
            ✅ <strong>Простота внедрения.</strong>
            <br /> Скачали программу, подключили свои кабинеты и начали работать — не нужно согласовывать интеграции и
            настраивать сложные схемы.
          </p>
          <p>
            ✅ <strong>Техническая поддержка.</strong>
            <br /> Если что‑то пошло не так — мы всегда на связи и быстро решим вопрос.
          </p>
          <p>
            ✅ <strong>Уверенность в завтрашнем дне.</strong>
            <br /> Какие бы изменения ни происходили у страховых компаний, СтрахоБот адаптируется к ним и продолжает
            работать.
          </p>
          <hr />
          <p>
            🎯{' '}
            <strong>
              Со СтрахоБотом вы превращаете рутинную работу в поток клиентов и доходов, экономите время, зарабатываете
              больше и работаете с удовольствием.
            </strong>
            <br /> Начните прямо сейчас — почувствуйте разницу с первой заявки!
          </p>
          <hr />
          <h2 id="🔑-как-начать">
            <strong>🔑 Как начать?</strong>
          </h2>
          <p>
            1️⃣ <Link to={downloadRoute.get()}>Скачайте СтрахоБот</Link> на Windows или MacOS
          </p>
          <p>
            2️⃣ Получите доступ к программе, через обращение{' '}
            <Link to="https://t.me/+7yyTulkX8HBkZjEy" target="_blank">
              в поддержку
            </Link>
          </p>
          <p>
            3️⃣ Попробуйте бесплатный тариф — и переходите на <strong>Базовый</strong>, когда почувствуете рост
          </p>
          <hr />
          <h2 id="🗨-остались-вопросы">
            <strong>🗨 Остались вопросы?</strong>
          </h2>
          <p>
            <Link to="https://t.me/+7yyTulkX8HBkZjEy" target="_blank">
              Напишите нам
            </Link>{' '}
            — и мы проведем для вас демо, расскажем всё и ответим на любые вопросы.
          </p>
          <p>
            🎯 Начните зарабатывать больше уже сегодня — вместе со <strong>СтрахоБотом</strong>.
          </p>
          <hr />
        </RichText>
        <DappInfoComponent />
      </Segments>
    </Block>
  )
})
